/*jshint esversion: 6 */
// import Vue from 'vue';
// import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  loading: false,
  search: '',
  sort_by: 'Latest',
  sort_options: [
    'Latest',
    'Date',
    'Description',
    'Person',
    // 'Step',
  ],
});
// State object
const state = initialState();
// Getter functions

// comment: "beschreibung a"
// created: "2022-01-30 15:10:37 UTC"
// extension: "jpg"
// id: 219
// image: "https://takting-images.s3.us-east-2.amazonaws.com/tworkpackage_images/61f69c5adf1cb"
// type: "image"
// updated: "2022-01-30 15:10:38 UTC"
// user: "Philipp Basler"

const getters = {
  getWorkPackageImagesSorted: (state, getters, rootState, rootGetters) => (payload) => {
    let images = rootGetters['Ultra/getUObjects']({type: `${payload.prefix}workpackageimages`, ids: payload.workpackage[`${payload.prefix}workpackageimages`]});
    let images_sorted = {};

    if (['Date', 'Description', 'Person'].includes(state.sort_by)) {
      let sort_prop = '';
      switch (state.sort_by) {
        case 'Date':
          sort_prop = 'created';
          break;
        case 'Description':
          sort_prop = 'comment';
          break;
        case 'Person':
          sort_prop = 'user';
          break;
      }
      if (state.search !== '') {
        if (sort_prop === 'created') {
          images = images.filter(image => image[sort_prop].substring(0,10).includes(state.search));
        } else {
          images = images.filter(image => image[sort_prop].includes(state.search));
        }
      }
      images.forEach(image => {
        let sort_string = image[sort_prop];
        if (sort_prop === 'created') {
          sort_string = sort_string.substring(0,10);
        } else if (sort_prop === 'comment') {
          sort_string = sort_string.substring(0,1).toUpperCase();
        }
        if (images_sorted[sort_string]) {
          images_sorted[sort_string].push(image);
          images_sorted[sort_string].sort((a, b) => {
            if (a[sort_prop] < b[sort_prop]) {
              return -1;
            }
            if (a[sort_prop] > b[sort_prop]) {
              return 1;
            }
            //gleich
            return 0;
          });
        } else {
          images_sorted[sort_string] = [image];
        }
      });
    } else if (state.sort_by === 'Step') {
      if (state.search !== '') {
        images = images.filter(image => image.step.text.includes(state.search));
      }
      images.forEach(image => {
        if (images_sorted[image.step.type]) {
          let steps = images_sorted[image.step.type];
          if (steps[image.step.text]) {
            steps[image.step.text].push(image);
            steps[image.step.text].sort((a, b) => {
              if (a.created < b.created) {
                return -1;
              }
              if (a.created > b.created) {
                return 1;
              }
              //gleich
              return 0;
            });
          } else {
            steps[image.step.text] = [image];
          }
        } else {
          images_sorted[image.step.type] = {
            [image.step.text]: [image]
          };
        }
      });
    } else {
      //sortby === 'Latest'
      if (state.search !== '') {
        images = images.filter(image => image.comment.includes(state.search));
      }
      images_sorted = {
        Latest: images.sort((a, b) => {
          if (a.created < b.created) {
            return -1;
          }
          if (a.created > b.created) {
            return 1;
          }
          //gleich
          return 0;
        })
      };
    }
    // sort keys by alphabet
    images_sorted = Object.keys(images_sorted).sort().reduce(
      (obj, key) => {
        obj[key] = images_sorted[key];
        return obj;
      },
      {}
    );
    return images_sorted;
  }
};
// Actions
const actions = {
  updateImageParams({commit}, payload) {
    commit('update_image_params', payload);
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  update_image_params(state, payload) {
    state[payload.param] = payload.value;
  },
  set_error(state, err) {
    state.error = err;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
